// Shared label/section primitives for the coverage create & update forms, so
// both render with the same spacing, weight and required-marker treatment.

export const SectionTitle = ({ children }) => (
  <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500">{children}</h4>
)

export const FieldLabel = ({ children, required }) => (
  <span className="mb-1 block text-xs font-medium text-gray-700">
    {children}
    {required && <span className="ml-0.5 text-red-500">*</span>}
  </span>
)
